// Importação de componentes e React
import React, { useEffect, useState } from "react";

// importação de estilização
import style from "./bodyReportBody.module.css";

// Importação de configuração manual
import localeText from "../../config/localeText";
import API_ROUTES from "../../utils/endpoints";
import api from "../../utils/api";

// Importação de biblioteca de terceiros
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import * as locales from "@mui/material/locale";
import { ToastContainer } from "react-toastify";
import CircularProgress from "@mui/material/CircularProgress";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";

function BodyReportBody() {
  // constante de input de dados
  const [people, setPeople] = useState([]);

  // constante de manipulação de elementos
  const [loading, setLoading] = useState(true);

  // constante de linguagem do datagrid
  const theme = useTheme();

  function formatDate(isoString) {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // mês começa do 0
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  }

  // Função que captura usuarios do banco
  const fetchPeople = async () => {
    try {
      const { data } = await api.get(API_ROUTES.GET_DADOS);

      const response = data.get_all_comunication;

      const mappedData = response.map((person, index) => ({
        id: index,
        name: person.contact_info.name,
        element: person.sector.name,
        contact: person.contact_info.phone,
        pwa: person.dateSendEmail ? formatDate(person.dateSendEmail) : "",
        sms: person.dateSendSMS ? formatDate(person.dateSendSMS) : "",
        email: person.dateSendEmail ? formatDate(person.dateSendEmail) : "",
        whatsapp: person.dateSendWPP ? formatDate(person.dateSendWPP) : "",
        confirmation: person.dateConfirmation
          ? formatDate(person.dateConfirmation)
          : "",
      }));

      setPeople(mappedData);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao buscar pessoas:", error);
      setLoading(false); // Mesmo em caso de erro, marca o carregamento como concluído
    }
  };

  // Captura usuarios do banco
  useEffect(() => {
    fetchPeople();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Colunas do datagrid
  const columns = [
    { field: "name", headerName: "Nome", width: 220 },
    { field: "element", headerName: "Elemento de Notificação", width: 210 },
    { field: "contact", headerName: "Contato", width: 210 },
    { field: "pwa", headerName: "PWA", width: 210 },
    { field: "sms", headerName: "SMS", width: 210 },
    { field: "email", headerName: "Email", width: 210 },
    { field: "whatsapp", headerName: "Whatsapp", width: 210 },
    { field: "confirmation", headerName: "Confirmação", width: 210 },
  ];

  // Tradução do datagrid
  const themeWithLocale = React.useMemo(
    () => createTheme(theme, locales["ptBR"]),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    ["ptBR", theme],
  );

  return (
    <div className={style["App"]}>
      {/* Renderização de Datagrid */}
      <div className={style["container-grid"]}>
        {!loading && (
          <Box sx={{ width: "100%", height: "100%" }}>
            <ThemeProvider theme={themeWithLocale}>
              <DataGrid
                sx={{
                  width: "87.5vw",
                  height: "84.9vh",
                  backgroundColor: "white",
                  fontSize: "0.7vw",
                }}
                rows={people}
                columns={columns}
                localeText={localeText}
                pageSize={15}
                paginationMode="client"
                pagination={true}
                location={"ptBR"}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 15,
                    },
                  },
                }}
              />
            </ThemeProvider>
          </Box>
        )}
      </div>

      {/* Renderização de Carregamento de pagina */}
      {loading && (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <ToastContainer />
    </div>
  );
}

export default BodyReportBody;
